import React, { useContext, useCallback, useEffect } from 'react';
import _ from 'lodash';
import { BreakpointTrackerContext } from '@jutro/layout';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { withRouter } from 'react-router-dom';
import { TranslatorContext } from '@jutro/locale';
import metadata from './AdditionalInformationComponent.metadata.json5';
import styles from '../LifeAgents.module.scss';
import InvestmentTableComponent from '../subcomponents/InvestmentTable/InvestmentTableComponent';
import LicenseTableComponent from '../subcomponents/LicenseTable/LicenseTableComponent';
import FormerEntityTableComponent from '../subcomponents/FormerEntityTable/FormerEntityTableComponent';

function AdditionalInformationComponent(props) {

   const { submissionVM, updateWizardData, pathUpdated } = props;
    const breakpoint = useContext(BreakpointTrackerContext);
    const { onValidate } = useValidation('UnderwritingComponent');
    const modelVM = _.get(submissionVM, pathUpdated);
    const translator = useContext(TranslatorContext);

    modelVM.value.isValidationReq = true;

    useEffect(() => {
        modelVM.licenseTable.value.sort((a,b) => a.number - b.number)
    }, [modelVM.licenseTable.value]);

    const getInsuredsProSerValue = () => {
        let insuredsProServices = '';
        const investmentTableVM = _.get(modelVM, 'investmentTable.children[0].inv1.aspects.availableValues');
        const investmentTableData = _.get(modelVM, 'investmentTable.value');

        investmentTableData.map((investment) => {
            if (investment.groCom2 !== undefined) {
                if (investment.inv1 !== 'Oth' && parseInt(investment.groCom2.amount, 10) > 0) {
                    const selectedService = investmentTableVM.filter((inv) => inv.code === investment.inv1)[0]
                    const serviceName = translator({
                        id: selectedService.name,
                        defaultMessage: selectedService.name
                    })

                    insuredsProServices = insuredsProServices !== '' ?
                        `${insuredsProServices}, ${serviceName}`
                        : serviceName
                } else if (investment.inv1 === 'Oth' && parseInt(investment.groCom2.amount, 10) > 0) {
                    if (investment.des3 !== undefined) {
                        insuredsProServices = insuredsProServices !== '' ?
                            `${insuredsProServices}, ${investment.des3}`
                            : investment.des3
                    }
                }
            }
        })

        return insuredsProServices
    }
    

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const overrideProps = {
        '@field': {
            showRequired: true,
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top'
        },
        licensingComponent: {
            data: modelVM.licenseTable,
            updateWizardData,
            submissionVM,
            LicenseTablePath: `${pathUpdated}.licenseTable`
        },
        formerEntityTableComponent: {
            visible: !_.isUndefined(modelVM.isTheAppSResForMai10.value) && modelVM.isTheAppSResForMai10.value === true,
            data: modelVM.formerEntityTable,
            updateWizardData,
            submissionVM,
            FormerEntityTablePath: `${pathUpdated}.formerEntityTable`,
        },
        formerEntity1: {
            visible: !_.isUndefined(modelVM.isTheAppSResForMai10.value) && modelVM.isTheAppSResForMai10.value === true
        },
        investmentTableComponent: {
            data: modelVM.investmentTable,
            updateWizardData,
            submissionVM,
            InvestmentTablePath: `${pathUpdated}.investmentTable`
        },
        insProSer2: {
            value: getInsuredsProSerValue()
        }
    };

    const resolvers = {
        resolveCallbackMap: {
            onValidate
        },
        resolveComponentMap: {
            licensingComponent: LicenseTableComponent,
            formerEntityTableComponent: FormerEntityTableComponent,
            investmentTableComponent: InvestmentTableComponent
        },
        resolveClassNameMap: styles
    };

    const readValue = useCallback(
        (id, path) => readViewModelValue(metadata.componentContent, _.get(submissionVM, pathUpdated), id, path, overrideProps),
        [overrideProps, pathUpdated, submissionVM]
    );

    const handleValueChange = useCallback(
        (value, changedPath) => {
            const fullPath = `${pathUpdated}.${changedPath}`;

            _.set(submissionVM, `${fullPath}`, value);

            updateWizardData(submissionVM);
        },
        [pathUpdated, submissionVM, updateWizardData]
    );

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={modelVM}
            // onModelChange={updateWizardData}
            resolveValue={readValue}
            overrideProps={overrideProps}
            onValidationChange={onValidate}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );
}

AdditionalInformationComponent.propTypes = wizardProps;
export default withRouter(AdditionalInformationComponent);
